const PLAN_FTYPES = ['floorplan', 'masterplan'];

function update_url(resp) {
    if (window.history && "pushState" in window.history) {
        const url = resp.data.data.url;
        window.history.pushState(null, "", url);
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = url;
        }
    }
}

function groupBy(objectArray, property, value) {
    return objectArray.reduce(function (acc, obj) {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj[value]);
        return acc;
    }, {});
}

function getFormData(filter_form) {
    let formData = new FormData(filter_form);
    let object = [];
    formData.forEach(function (value, key) {
        const o = {
            name: key,
            value: value,
        };
        object.push(o);
    });
    const pieces = groupBy(object, "name", "value");
    formData = new FormData();
    for (const piece in pieces) {
        if (pieces.hasOwnProperty(piece)) {
            pieces[piece] = pieces[piece].filter((string) => string !== '');
            formData.append(piece, pieces[piece].join("|"));
        }
    }
    return formData;
}

function oiFilterDisableForm(oi_filter_form) {
    if (oi_filter_form) {
        let i;
        // Disable all form inputs
        for (i = 0; i < oi_filter_form.elements.length; i++) {
            oi_filter_form.elements[i].setAttribute("disabled", "disabled");
        }
        // Disable all elements with class of "oi-disable-while-pending"
        const to_disable = document.getElementsByClassName(
            "oi-disable-while-pending"
        );
        for (i = 0; i < to_disable.length; i++) {
            to_disable[i].setAttribute("disabled", "disabled");
        }
        // Reduce the opacity of all elements with class of "model-filters"
        // ?? Can we just do this for all elements inside the form ??
        const model_filters = document.getElementsByClassName("model-filters");
        for (i = 0; i < model_filters.length; i++) {
            model_filters[i].style.opacity = "0.6";
        }
        // ?? What about an overlay and spinner ??
    }
}

function oiFilterEnableForm(oi_filter_form) {
    if (oi_filter_form) {
        setTimeout(function () {
            let i;
            // Remove the disabled attribute and value from inputs.
            for (i = 0; i < oi_filter_form.elements.length; i++) {
                oi_filter_form.elements[i].disabled = false;
                oi_filter_form.elements[i].removeAttribute("disabled");
            }
            // Remove disabled from all elements with class of "oi-disable-while-pending"
            const to_disable = document.getElementsByClassName(
                "oi-disable-while-pending"
            );
            for (i = 0; i < to_disable.length; i++) {
                to_disable[i].disabled = false;
                to_disable[i].removeAttribute("disabled");
            }
            // Reset the opacity of all elements with class of "model-filters"
            const model_filters =
                document.getElementsByClassName("model-filters");
            for (i = 0; i < model_filters.length; i++) {
                model_filters[i].style.opacity = "1";
            }
        }, 500);
    }
}

function oiFilterAjaxBeforesend(oi_filter_form, from_infinite) {
    if (from_infinite === undefined || from_infinite === false) {
        oiFilterDisableForm(oi_filter_form);
    }
}

function oiFilterGetResults(oi_filter_form, results) {
    let ftype = oi_filter_form.dataset.filterType;
    const url = `/xhr/filter/${ftype}/`;
    const formData = getFormData(oi_filter_form);
    const detailPage = oi_filter_form.dataset.detailPage ? oi_filter_form.dataset.detailPage : false;
    oi.axios({
        method: "post",
        url: url,
        data: formData,
        headers: {
            "Content-Type": "application/json",
        },
        transformRequest: [
            function (data, headers) {
                // We're not really transforming the request, but this function runs
                // before the ajax posts.
                oiFilterAjaxBeforesend(oi_filter_form, false);
                // We let the data pass-through unchanged.
                return data;
            },
        ],
    })
        .then(function (resp) {
            if (resp.data.data.result_list) {
                if (resp.data.options) {
                    const options = resp.data.options;
                    for (const id in options) {
                        document.getElementById(option).innerHTML =
                            options[option];
                    }
                }
                if (resp.data.paginator && resp.data.paginator !== "") {
                    const pageinput =
                        oi_filter_form.querySelector('input[name="page"]');
                    pageinput.value = resp.data.paginator.next;
                }
                results.innerHTML = resp.data.data.result_list;

                const oi_filter_amount = document.getElementById("oi-filter-amount");
                if (oi_filter_amount !== null && resp.data.data.amount) {
                    oi_filter_amount.innerHTML = resp.data.data.amount
                }

                if (resp.data.result_list_lot) {
                    const results_lot = document.getElementById(
                        "oi-filter-results-lot"
                    );
                    results_lot.innerHTML = resp.data.result_list;
                }
                if (resp.data.result_list_land) {
                    const results_land = document.getElementById(
                        "oi-filter-results-land"
                    );
                    results_land.innerHTML = resp.data.result_list;
                }

                if (resp.data.map_items && resp.data.map_items !== "") {
                    const map_items =
                        document.querySelector(".oi-all-map-items");
                    map_items.innerHTML = resp.data.map_items;
                }

                // let county_description = document.getElementById('county_description');
                // if (county_description != null) {
                //   if (resp['data'].hasOwnProperty('county_description')) {
                //     county_description.innerHTML = resp['data']['county_description'];
                //   } else {
                //     county_description.innerHTML = '';
                //   }
                // }
                update_url(resp);

                if (window.afterResultsSuccess !== undefined) {
                    window.afterResultsSuccess();
                }

                if (oi.loaded.map['oi-map'] && !detailPage) {
                    // if (ftype === 'lot' || ftype === 'mlslisting') {
                    //     ftype = 'location';
                    // }
                    console.log(ftype)
                    oi.loaded.map['oi-map'].set_markers(ftype);
                    oi.loaded.map['oi-map'].fit();
                }
            }
        })
        .catch(function (error) {
            if (error.response) {
                if (error.response.status == 400) {
                    let msg = "";
                    const errors = error.response.data.errors;
                    for (let err in errors) {
                        let x = errors[err];
                        msg = `${x.code} - ${x.description}\n`;
                    }
                    oiFilterEnableForm(oi_filter_form);
                } else if (error.response.status == 302) {
                    // Redirecting
                    window.location.href = error.response.data.data.redirect;
                }
            } else if (error.request) {
                console.error(error.request);
            } else {
                console.error(error.message);
            }
        })
        .then(function () {
            const name_input = oi_filter_form.querySelector('input[name="m"]');
            if (name_input !== null) {
                name_input.value = "0";
            }
            oiFilterEnableForm(oi_filter_form);
        });
}

function handleCloneCountyOptions(countySelectEl) {
  // Store county options for each region
  const countyOptionsClone = {};
  let options = countySelectEl.options;

  for (let i = 0; i < options.length; i++) {
    let state = options[i].dataset.state;
    if (state) {
      if (!countyOptionsClone[state]) {
        countyOptionsClone[state] = [];
      }
      countyOptionsClone[state].push(options[i].cloneNode(true));
    }
  }

  // Make cloned options read-only
  Object.freeze(countyOptionsClone);
  return countyOptionsClone;
}

function bindRegionSelectValues(regionValue) {
  let allRegionSelects = document.querySelectorAll('.state-select');
  for (let i = 0; i < allRegionSelects.length; i++) {
    // Do not bind home page search form region select
    if (!allRegionSelects[i].classList.contains('oi-search-field')) {
      allRegionSelects[i].value = regionValue;
    }
  }
}

function bindCountySelectValues(countyValue) {
  let allCountySelects = document.querySelectorAll('.county-select');
  for (let i = 0; i < allCountySelects.length; i++) {
    // Do not bind home page search form county select
    if (!allCountySelects[i].classList.contains('oi-search-field')) {
      allCountySelects[i].value = countyValue;
    }
  }
}

function handleUpdateCountyDropdown(selectedRegion, countySelectEl, countyOptionsClone) {
  // Check for county cookie value
  let countyCookie = oi.utils.cookie.get('county');

  // Remove all options from county select
  while (countySelectEl.options.length > 0) {
    countySelectEl.remove(0);
  }

  // Add default option
  let defaultOption = document.createElement('option');
  defaultOption.text = 'County';
  defaultOption.value = '';
  countySelectEl.add(defaultOption);

  // Check if selected region has options, add them to county select
  if (selectedRegion) {
    // Add cloned options for selected region
    if (selectedRegion in countyOptionsClone) {
      for (let j = 0; j < countyOptionsClone[selectedRegion].length; j++) {
        let option = countyOptionsClone[selectedRegion][j].cloneNode(true);
        countySelectEl.add(option);
      }
    }
    if (countyCookie) {
      // Set county select value to cookie value
      countySelectEl.value = countyCookie.value;
    }
    // Enable county select
    countySelectEl.removeAttribute('disabled');
  } else {
    // Do not add any options, disable county select
    countySelectEl.setAttribute('disabled', '');
  }
}

function handleRegionSelectChange(regionValue, countySelectEls, countyOptionsClone) {

  bindRegionSelectValues(regionValue);
  let selectedRegion = regionValue.slice(1);
  let countyChanged = false;
  // Clear county select value
  for (let i = 0; i < countySelectEls.length; i++) {
    if (countySelectEls[i].value) {
      countySelectEls[i].value = '';
      // Need to fire change event on last county select
      countyChanged = true;
    }
  }

  for (let i = 0; i < countySelectEls.length; i++) {
    handleUpdateCountyDropdown(selectedRegion, countySelectEls[i], countyOptionsClone);
  }
}

function handleCountySelectChange(countySelectEl, priceSelectEls) {
  bindCountySelectValues(countySelectEl.value);
  if (countySelectEl.value) {
    // Enable price select
    for (let i = 0; i < priceSelectEls.length; i++) {
      priceSelectEls[i].removeAttribute('disabled');
    }
  } else {
    // Clear price select value, disable price select
    for (let i = 0; i < priceSelectEls.length; i++) {
      priceSelectEls[i].value = '';
      priceSelectEls[i].setAttribute('disabled', '');
    }
  }
}


function handleCountyRedirect(option) {
  let url = ``;
  if (option.dataset.state && option.value && option.text) {
    // Slugify county name
    let state = option.dataset.state.toLowerCase();
    let county_slug = option.text.toLowerCase().replace(/\s/g, '-');
    // Get url for redirect to plan list for county
    url = `/new-homes/floorplans/${state}/${county_slug}/`;
    window.location.href = url;
  } else {
    // Redirect to masterplan list, region will be set by cookie, if it exists
    url = `/new-homes/floorplans/`;
    window.location.href = url;
  }
}

window.addEventListener("load", () => {
    const oi_filter_forms = document.getElementsByClassName("oi-filter-form");
    if (oi_filter_forms) {
      for (let i = 0; i < oi_filter_forms.length; i++) {
        var fType = oi_filter_forms[i].dataset.filterType;
        let oi_filter_clickables =
            oi_filter_forms[i].querySelectorAll(".oi-filter-click");
        let oi_filter_changables =
            oi_filter_forms[i].querySelectorAll(".oi-filter-change");

        oi_filter_clickables.forEach((elem) => {
            elem.addEventListener("click", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_forms[i], oi_filter_results);
            });
        });

        oi_filter_changables.forEach((elem) => {
            elem.addEventListener("change", (e) => {
                e.preventDefault();
                oiFilterGetResults(oi_filter_forms[i], oi_filter_results);
            });
        });

        let oi_filter_reset = oi_filter_forms[i].querySelectorAll(".oi-filter-reset");
        let oi_filter_results = document.getElementById("oi-filter-results");
        if (oi_filter_reset !== null && oi_filter_results !== null) {
            oi_filter_reset.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                    let i;
                    e.preventDefault();
                    const to_clear =
                        document.getElementsByClassName("oi-clear-on-reset");
                    if (to_clear) {
                        for (i = 0; i < to_clear.length; i++) {
                            if (to_clear[i].type == "select-one") {
                                to_clear[i].selectedIndex = 0;
                            }
                            if (to_clear[i].id == "boyl-input") {
                                to_clear[i].value = false;
                            }
                            if (to_clear[i].type == "checkbox") {
                                to_clear[i].checked = false;
                            }
                        }
                    }
                    const buttons_to_reset =
                        document.getElementsByClassName("filter-button-on");
                    if (buttons_to_reset) {
                        for (i = 0; i < buttons_to_reset.length; i++) {
                            buttons_to_reset[i].classList.remove(
                                "filter-button-on"
                            );
                        }
                    }
                    oiFilterGetResults(oi_filter_forms[i], oi_filter_results);
                });
            });
        }
      }
    }

    const stateSelectEls = document.querySelectorAll('.state-select');
    const countySelectEls = document.querySelectorAll('.county-select');
    const priceSelectEls = document.querySelectorAll('.price-select');

    var countyOptionsClone;

    if (stateSelectEls.length && countySelectEls.length && priceSelectEls.length) {
      countyOptionsClone = handleCloneCountyOptions(countySelectEls[0]);
      // Handle region select change
      for (let i = 0; i < stateSelectEls.length; i++) {
        stateSelectEls[i].addEventListener('change', (e) => {
          e.preventDefault();
          let selectedRegion = e.target.value;
          handleRegionSelectChange(selectedRegion, countySelectEls, countyOptionsClone);
        });
      }

      // Handle county select change
      for (let i = 0; i < countySelectEls.length; i++) {
        countySelectEls[i].addEventListener('change', (e) => {
          e.preventDefault();
          handleCountySelectChange(countySelectEls[i], priceSelectEls);
          if (PLAN_FTYPES.includes(fType)) {
            let option = countySelectEls[i].options[countySelectEls[i].selectedIndex];
            handleCountyRedirect(option);
          }
        });
      }

      for (let i = 0; i < stateSelectEls.length; i++) {
        // check value on load, update UI
        if (stateSelectEls[i].value) {
          let selectedRegion = stateSelectEls[i].value.slice(1);
          for (let j = 0; j < countySelectEls.length; j++) {
            handleUpdateCountyDropdown(selectedRegion, countySelectEls[j], countyOptionsClone);
            if (j === countySelectEls.length - 1 && countySelectEls[j].value && fType === 'masterplan') {
              // Fire change event on last county select to update page
              countySelectEls[j].dispatchEvent(new Event('change'));
            }
          }
          if (fType === 'masterplan' && !window.location.href.includes('filter')) {
            // Filter the masterplans on the selected region on page load
            let oi_filter_form = stateSelectEls[i].closest('.oi-filter-form');
            let oi_filter_results = document.getElementById('oi-filter-results');
            oiFilterGetResults(oi_filter_form, oi_filter_results);
          }
          break;
        }
      }

      for (let i = 0; i < countySelectEls.length; i++) {
        // check value on load, update UI
        if (countySelectEls[i].value) {
          // Enable price select
          for (let j = 0; j < priceSelectEls.length; j++) {
            priceSelectEls[j].removeAttribute('disabled');
          }
          break;
        }
      }

  }

    // This function OVERWRITES the default onpopstate behavior, which is perhaps desireable.
    // If overwriting is not necessary, the alternate function below is more desirable, as
    // it ADDS functiontionality.
    // window.onpopstate = function (event) {
    //     location.reload();
    // }

    window.addEventListener("popstate", (e) => {
        location.reload();
    });
});
